import { LocaleId, TranslationDictionaryMapping } from '@i18n';
import { AddressTranslationDictionary } from '../../models/i18n/address-translation-dictionary.interface';

export const IEAddressTranslationDictionaryMapping: TranslationDictionaryMapping<AddressTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      ADDRESS_ID_ERROR_REQUIRED: 'Please select an address',
      ADDRESS_ID_LABEL: 'Search for your address',
      ADDRESS_ID_PLACEHOLDER: 'Start typing your address or Eircode',
      ADDRESS_IS_OVERRIDE_ADDRESS_ERROR_REQUIRED: 'Please confirm',
      ADDRESS_IS_OVERRIDE_ADDRESS_DEFAULT_LABEL: 'Is residential address',
      ADDRESS_IS_OVERRIDE_ADDRESS_TITLE:
        'This property is listed as a commercial address',
      ADDRESS_LINE_1_ERROR_MAX_LENGTH:
        'Please provide a value that is {{ maxLength }} characters or fewer',
      ADDRESS_LINE_1_ERROR_REQUIRED: 'Please provide an address line',
      ADDRESS_LINE_1_ERROR_RESTRICTED_CHARACTERS:
        'Please provide a valid address line',
      ADDRESS_LINE_1_LABEL: 'Address line 1',
      ADDRESS_LINE_2_ERROR_MAX_LENGTH:
        'Please provide a value that is {{ maxLength }} characters or fewer',
      ADDRESS_LINE_2_ERROR_RESTRICTED_CHARACTERS:
        'Please provide a valid address line',
      ADDRESS_LINE_2_LABEL: 'Address line 2',
      ADDRESS_LINE_3_ERROR_ALPHABETICAL: 'Please provide a valid town / city',
      ADDRESS_LINE_3_ERROR_MAX_LENGTH:
        'Please provide a value that is {{ maxLength }} characters or fewer',
      ADDRESS_LINE_3_ERROR_REQUIRED: 'Please provide a town / city',
      ADDRESS_LINE_3_LABEL: 'Town/City',
      ADDRESS_LINE_4_ERROR_ALPHABETICAL: 'Please provide a valid county',
      ADDRESS_LINE_4_ERROR_MAX_LENGTH:
        'Please provide a value that is {{ maxLength }} characters or fewer',
      ADDRESS_LINE_4_ERROR_REQUIRED: 'Please provide a county',
      ADDRESS_LINE_4_LABEL: 'County',
      ADDRESS_POSTAL_CODE_ERROR_POSTCODE: 'Please provide a valid Eircode',
      ADDRESS_POSTAL_CODE_ERROR_REQUIRED: 'Please provide a Eircode',
      ADDRESS_POSTAL_CODE_LABEL: 'Eircode',
      ADDRESS_SAME_AS_ADDRESS_DEFAULT_LABEL: 'Same as address',
      ADDRESS_SEARCH_LABEL: 'Search for address',
      ADDRESS_SEARCH_PLACEHOLDER: 'Search for an address...',
      ADDRESS_TABS_MANUAL_LABEL: 'Manual address',
      ADDRESS_TABS_SEARCH_LABEL: 'Find address',
      ADDRESS_SELECT_DROPDOWN_DEFAULT_NO_RESULTS:
        'No address found for the postal code',
      ADDRESS_SELECT_DROPDOWN_DEFAULT_PLACEHOLDER: 'Select your address',
      ADDRESS_OVERRIDE_CHECKBOX_LABEL:
        'I confirm that this appliance is for domestic use only',
      ADDRESS_OVERRIDE_CHECKBOX_TEXT:
        'We can only register appliances for domestic use',
    },
    [LocaleId.English_Ireland]: {
      ADDRESS_ID_ERROR_REQUIRED: 'Please select an address',
      ADDRESS_ID_LABEL: 'Search for your address',
      ADDRESS_ID_PLACEHOLDER: 'Start typing your address or Eircode',
      ADDRESS_IS_OVERRIDE_ADDRESS_ERROR_REQUIRED: 'Please confirm',
      ADDRESS_IS_OVERRIDE_ADDRESS_DEFAULT_LABEL: 'Is residential address',
      ADDRESS_IS_OVERRIDE_ADDRESS_TITLE:
        'This property is listed as a commercial address',
      ADDRESS_LINE_1_ERROR_MAX_LENGTH:
        'Please provide a value that is {{ maxLength }} characters or fewer',
      ADDRESS_LINE_1_ERROR_REQUIRED: 'Please provide an address line',
      ADDRESS_LINE_1_ERROR_RESTRICTED_CHARACTERS:
        'Please provide a valid address line',
      ADDRESS_LINE_1_LABEL: 'Address line 1',
      ADDRESS_LINE_2_ERROR_MAX_LENGTH:
        'Please provide a value that is {{ maxLength }} characters or fewer',
      ADDRESS_LINE_2_ERROR_RESTRICTED_CHARACTERS:
        'Please provide a valid address line',
      ADDRESS_LINE_2_LABEL: 'Address line 2',
      ADDRESS_LINE_3_ERROR_ALPHABETICAL: 'Please provide a valid town / city',
      ADDRESS_LINE_3_ERROR_MAX_LENGTH:
        'Please provide a value that is {{ maxLength }} characters or fewer',
      ADDRESS_LINE_3_ERROR_REQUIRED: 'Please provide a town / city',
      ADDRESS_LINE_3_LABEL: 'Town/City',
      ADDRESS_LINE_4_ERROR_ALPHABETICAL: 'Please provide a valid county',
      ADDRESS_LINE_4_ERROR_MAX_LENGTH:
        'Please provide a value that is {{ maxLength }} characters or fewer',
      ADDRESS_LINE_4_ERROR_REQUIRED: 'Please provide a county',
      ADDRESS_LINE_4_LABEL: 'County',
      ADDRESS_POSTAL_CODE_ERROR_POSTCODE: 'Please provide a valid Eircode',
      ADDRESS_POSTAL_CODE_ERROR_REQUIRED: 'Please provide a Eircode',
      ADDRESS_POSTAL_CODE_LABEL: 'Eircode',
      ADDRESS_SAME_AS_ADDRESS_DEFAULT_LABEL: 'Same as address',
      ADDRESS_SEARCH_LABEL: 'Search for address',
      ADDRESS_SEARCH_PLACEHOLDER: 'Search for an address...',
      ADDRESS_TABS_MANUAL_LABEL: 'Manual address',
      ADDRESS_TABS_SEARCH_LABEL: 'Find address',
      ADDRESS_SELECT_DROPDOWN_DEFAULT_NO_RESULTS:
        'No address found for the postal code',
      ADDRESS_SELECT_DROPDOWN_DEFAULT_PLACEHOLDER: 'Select your address',
      ADDRESS_OVERRIDE_CHECKBOX_LABEL:
        'I confirm that this appliance is for domestic use only',
      ADDRESS_OVERRIDE_CHECKBOX_TEXT:
        'We can only register appliances for domestic use',
    },
  };
